import { Navigate, Outlet } from "react-router-dom";

export const PrivateRoute = () => {
  const token = localStorage.getItem("@MAXITRANS_TOKEN_ADMIN:");

  return token ? <Outlet /> : <Navigate to="/" />;
};
